import HomePage from './HomePage';

export default HomePage;



// WEBPACK FOOTER //
// ./src/containers/HomePage/index.js